import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function ScraperUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-2330">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2331">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2332">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2333">
            Google Maps data for every{' '}
            <span className="text-blue-600" data-id="element-2334">use case</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2335">
            Whether you're generating leads, researching markets, or analyzing
            competitors — our Google Maps scraper powers your growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2336">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2337">
            <div data-id="element-2338">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2339">
                B2B lead generation
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2340">
                Use our Google Maps email extractor to build highly targeted
                lists of local business owners for cold email and calling
                campaigns.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2341">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2342" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2343">
                We generate 5,000 qualified leads per week from Google Maps data
                alone.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2344">
                — James T., Growth marketer
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2345">
            <div data-id="element-2346">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2347">
                Market research
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2348">
                Use our google reviews scraper to analyze local business
                density, ratings, and review sentiment across any geography to
                inform expansion decisions.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2349">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2350" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2351">
                Google Maps data from Openmart helped us identify 3 underserved
                markets in our first week.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2352">
                — Sarah M., Strategy lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2353">
            <div data-id="element-2354">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2355">
                Competitor analysis
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2356">
                Track competitor locations, ratings, and review sentiment at
                scale using structured Google Maps data.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2357">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2358" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2359">
                We monitor 10,000 competitor locations and their review trends
                automatically.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2360">
                — David C., Marketing director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}